<div class="common-drop-down-arrow"
  [className]="validate && isValidated(selectedItemId) ? 'invalid-drop-down-talked-to' : 'common-drop-down-arrow'">
  <span class="name">{{name}}</span>
  <ng-select (blur)="onSaveModel()" (focus)="onSaveState()" [clearable]="false" [(ngModel)]="selectedItemId" class="custom"
    [disabled]="!!disabled" (change)="onChange()" (focus)="onOpen()" [items]="items" dropdownPosition="top" 
    [class.hide-arrow]="noArrowOnDisabled && disabled"
    [class.recommended-yellow-background]="isRequired() && !requiredRedBackground"
    [class.required-red-background]="isRequired() && requiredRedBackground"
    >
    <ng-template ng-label-tmp let-item="item" >
      {{ getStakeholderDisplayName(item) }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <ng-container [ngSwitch]="item.stakeholderType">
          <img [src]="getStakeholderIconType(item)" class="stakeholder-icon">
            {{ getStakeholderDisplayName(item) }}
        </ng-container>
    </ng-template>
  </ng-select>
</div>
